import { type FC } from 'react'

import a from '@core/assets/v2/icons/character/regular/Icon-A-Regular.svg'
import addDescription from '@core/assets/v2/icons/character/regular/Icon-AddDescription-Regular.svg'
import attachment from '@core/assets/v2/icons/character/regular/Icon-Attachment-Regular.svg'
import bold from '@core/assets/v2/icons/character/regular/Icon-Bold-Regular.svg'
import bulletList from '@core/assets/v2/icons/character/regular/Icon-BulletList-Regular.svg'
import centerAlignment from '@core/assets/v2/icons/character/regular/Icon-CenterAlignment-Regular.svg'
import disconnect from '@core/assets/v2/icons/character/regular/Icon-Disconnect-Regular.svg'
import enter from '@core/assets/v2/icons/character/regular/Icon-Enter-Regular.svg'
import enterReverse from '@core/assets/v2/icons/character/regular/Icon-EnterReverse-Regular.svg'
import formatting from '@core/assets/v2/icons/character/regular/Icon-Formatting-Regular.svg'
import isertAbove from '@core/assets/v2/icons/character/regular/Icon-IsertAbove-Regular.svg'
import isertBelow from '@core/assets/v2/icons/character/regular/Icon-IsertBelow-Regular.svg'
import italic from '@core/assets/v2/icons/character/regular/Icon-Italic-Regular.svg'
import justifiedAlignment from '@core/assets/v2/icons/character/regular/Icon-JustifiedAlignment-Regular.svg'
import leftAlignment from '@core/assets/v2/icons/character/regular/Icon-LeftAlignment-Regular.svg'
import link from '@core/assets/v2/icons/character/regular/Icon-Link-Regular.svg'
import long from '@core/assets/v2/icons/character/regular/Icon-Long-Regular.svg'
import numberedList from '@core/assets/v2/icons/character/regular/Icon-NumberedList-Regular.svg'
import rightAlignment from '@core/assets/v2/icons/character/regular/Icon-RightAlignment-Regular.svg'
import short from '@core/assets/v2/icons/character/regular/Icon-Short-Regular.svg'
import strikethrough from '@core/assets/v2/icons/character/regular/Icon-Strikethrough-Regular.svg'
import text from '@core/assets/v2/icons/character/regular/Icon-Text-Regular.svg'
import underline from '@core/assets/v2/icons/character/regular/Icon-Underline-Regular.svg'
import attachmentSolid from '@core/assets/v2/icons/character/solid/Icon-Attachment-Solid.svg'
import disconnectSolid from '@core/assets/v2/icons/character/solid/Icon-Disconnect-Solid.svg'
import linkSolid from '@core/assets/v2/icons/character/solid/Icon-Link-Solid.svg'
import textSolid from '@core/assets/v2/icons/character/solid/Icon-Text-Solid.svg'

import { createIcon } from './createIcon'
import type { CharacterIconName, IconProps } from './types'

export const IconA = createIcon(a, 'A')
export const IconAddDescription = createIcon(addDescription, 'AddDescription')
export const IconAttachment = createIcon(attachment, 'Attachment')
export const IconBold = createIcon(bold, 'Bold')
export const IconBulletList = createIcon(bulletList, 'BulletList')
export const IconCenterAlignment = createIcon(centerAlignment, 'CenterAlignment')
export const IconDisconnect = createIcon(disconnect, 'Disconnect')
export const IconCharacterEnter = createIcon(enter, 'CharacterEnter')
export const IconEnterReverse = createIcon(enterReverse, 'EnterReverse')
export const IconFormatting = createIcon(formatting, 'Formatting')
export const IconIsertAbove = createIcon(isertAbove, 'IsertAbove')
export const IconIsertBelow = createIcon(isertBelow, 'IsertBelow')
export const IconItalic = createIcon(italic, 'Italic')
export const IconJustifiedAlignment = createIcon(justifiedAlignment, 'JustifiedAlignment')
export const IconLeftAlignment = createIcon(leftAlignment, 'LeftAlignment')
export const IconLink = createIcon(link, 'Link')
export const IconLong = createIcon(long, 'Long')
export const IconNumberedList = createIcon(numberedList, 'NumberedList')
export const IconRightAlignment = createIcon(rightAlignment, 'RightAlignment')
export const IconShort = createIcon(short, 'Short')
export const IconStrikethrough = createIcon(strikethrough, 'Strikethrough')
export const IconText = createIcon(text, 'Text')
export const IconUnderline = createIcon(underline, 'Underline')
export const IconAttachmentSolid = createIcon(attachmentSolid, 'AttachmentSolid')
export const IconDisconnectSolid = createIcon(disconnectSolid, 'DisconnectSolid')
export const IconLinkSolid = createIcon(linkSolid, 'LinkSolid')
export const IconTextSolid = createIcon(textSolid, 'TextSolid')

export const characterIcons: Record<CharacterIconName, FC<IconProps>> = {
    A: IconA,
    AddDescription: IconAddDescription,
    Attachment: IconAttachment,
    Bold: IconBold,
    BulletList: IconBulletList,
    CenterAlignment: IconCenterAlignment,
    Disconnect: IconDisconnect,
    CharacterEnter: IconCharacterEnter,
    EnterReverse: IconEnterReverse,
    Formatting: IconFormatting,
    IsertAbove: IconIsertAbove,
    IsertBelow: IconIsertBelow,
    Italic: IconItalic,
    JustifiedAlignment: IconJustifiedAlignment,
    LeftAlignment: IconLeftAlignment,
    Link: IconLink,
    Long: IconLong,
    NumberedList: IconNumberedList,
    RightAlignment: IconRightAlignment,
    Short: IconShort,
    Strikethrough: IconStrikethrough,
    Text: IconText,
    Underline: IconUnderline,
    AttachmentSolid: IconAttachmentSolid,
    DisconnectSolid: IconDisconnectSolid,
    LinkSolid: IconLinkSolid,
    TextSolid: IconTextSolid,
}
